module.exports = __webpack_public_path__ + "img/banner-aws.662e8a70.jpg";